The type of the address component.

Currently, the following components are defined:

- `Apartment` indicates an address line for an apartment, unit or suite.
- `State` indicates a country subdivision such as a district, internal territory, province, or state.
